import getConfig from 'next/config';
import { Record, Static, String, Null } from 'runtypes';

import { sendHttpRequest } from '../utilities/sendHttpRequest';

const { publicRuntimeConfig } = getConfig();
export const ACCOUNT_MANAGEMENT_URL = `${publicRuntimeConfig.stargatewayHost}/v2/family`;

const GetPricingPlanResponse = Record({
  current: String,
  effectiveAt: String.Or(Null),
  pending: String.Or(Null),
  pendingPlanChangeProcessingDate: String.Or(Null),
  nextBillingDate: String.Or(Null),
  mobileProtectionStartDate: String.Or(Null)
});
type GetPricingPlanResponseType = Static<typeof GetPricingPlanResponse>;

function getPricingPlan(authToken: string) {
  return sendHttpRequest<GetPricingPlanResponseType>({
    method: 'get',
    url: `${ACCOUNT_MANAGEMENT_URL}/pricing-plan`,
    headers: { authorization: authToken },
    validateResponse: GetPricingPlanResponse.check
  });
}

interface PostChangePlanArgs {
  pricingPlanName: string;
  authToken: string;
  retries?: number;
  backoffMs?: number;
}

export default {
  getPricingPlan
};
